import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const SpartanBurgersLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=HCSM_MYTIXX&orgid=57730#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DHCSM_MYTIXX%26orgid%3D57730"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com.",
    description:
      "Click Continue and connect your Hub City Spartanburgers account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <SpartanBurgersLink /> account within
        24 hours of purchase. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Hub City Spartanburgers Mini Plan Madness work?",
    description:
      "The Hub City Spartanburgers Flex Program allows fans to select any seat to select games hosted by the Spartanburgers. Simply log into your MLB.com and select games.",
  },
  {
    title: "Interested in more than 9 games?",
    description: (
      <>
        Please visit Hub City's MILB website:{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://www.milb.com/hub-city/tickets/season-ticket-memberships"
        >
          Hub City Season Ticket Memberships
        </Link>
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Hub City Spartanburgers{" "}
        <SpartanBurgersLink /> Account.
      </>
    ),
  },
];

export const RegistrationTerms = () => (
  <>
    By proceeding, you agree to receive account-related notifications and
    marketing communications from the Hub City Spartanburgers and confirm that
    you have read and agree to our{" "}
    <Link
      href={"https://www.attend.tech/terms-of-use"}
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href={"https://www.attend.tech/privacy-policy"}
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);
